__turbopack_context__.v({
  "button": "Button-module___HZUfW__button",
  "fullWidth": "Button-module___HZUfW__fullWidth",
  "iconLeft": "Button-module___HZUfW__iconLeft",
  "iconRight": "Button-module___HZUfW__iconRight",
});
